import React from 'react'
import { Modal } from '../imports'

const ViewContentModal = () => {
  return (
    <Modal>
      <h2>ViewContentModal</h2>
    </Modal>
  )
}

export default ViewContentModal